module.exports = __webpack_public_path__ + "static/img/groundabout7.8ec89648.png";